import { UserTutorialCompletionKey } from '../../../types/userTutorialCompletions';
import { SpBr } from '../../../../commonv3/components/atoms/layouts/br';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import * as React from 'react';
import './userTutorialDetailAction.module.scss';

export const UserTutorialDetailAction = ({ page_key, hasCompleted, createCompletion, loading }) => {
    switch (page_key) {
        case UserTutorialCompletionKey.KEY_COMPLETE_TUTORIAL_COURSE:
            return (
                <div styleName="pane-complete">
                    <div styleName="complete-text">
                        取り組めた方は<SpBr />完了ボタンを押そう！
                    </div>
                    <Button
                        onClick={createCompletion}
                        loading={loading}
                        type="primary"
                        styleName="complete-button"
                        disabled={hasCompleted}
                        id={'complete-button'}
                    >
                        {hasCompleted ? '完了済みです' : '完了'}
                    </Button>
                </div>
            );
        case UserTutorialCompletionKey.KEY_JOIN_SLACK:
            return (
                <div styleName="pane-complete">
                    <div styleName="complete-text">
                        取り組めた方は<SpBr />完了ボタンを押そう！
                    </div>
                    <Button
                        onClick={createCompletion}
                        loading={loading}
                        type="primary"
                        styleName="complete-button"
                        disabled={hasCompleted}
                        id={'complete-button'}
                    >
                        {hasCompleted ? '完了済みです' : '完了'}
                    </Button>
                </div>
            );
        case UserTutorialCompletionKey.KEY_RESERVE_COACHING:
            return (
                <div styleName="pane-complete">
                    <div styleName="complete-text">初回コーチングを予約しよう！</div>
                    <Button
                        onClick={() => GlobalStatesV3.routing.push(V3Routes.coachingSessions())}
                        loading={loading}
                        type="primary"
                        styleName="complete-button"
                        disabled={hasCompleted}
                        id={'reserve-button'}
                    >
                        {hasCompleted ? '予約済みです' : '予約画面に行く'}
                    </Button>
                    {hasCompleted && (
                        <Button
                            onClick={() => GlobalStatesV3.routing.push(V3Routes.reservations())}
                            loading={loading}
                            type="normal"
                            styleName="complete-button"
                            id={'confirm-reservations-button'}
                        >
                            予約を確認する
                        </Button>
                    )}
                </div>
            );
        case UserTutorialCompletionKey.KEY_START_COURSE:
            return (
                <div styleName="pane-complete">
                    <div styleName="complete-text">コースを１つ受講しよう！</div>
                    <Button
                        onClick={() => GlobalStatesV3.routing.push(V3Routes.courses())}
                        loading={loading}
                        type="primary"
                        styleName="complete-button"
                        disabled={hasCompleted}
                        id="uncompleted-course-button"
                    >
                        {hasCompleted ? '１つ以上のコースを受講済です' : 'コース一覧へ行く'}
                    </Button>
                    {hasCompleted && (
                        <Button
                            onClick={() => GlobalStatesV3.routing.push(V3Routes.courses())}
                            loading={loading}
                            type="normal"
                            styleName="complete-button"
                            id="course-button"
                        >
                            コース一覧へ行く
                        </Button>
                    )}
                </div>
            );
        default:
            return (
                <div styleName="pane-complete">
                    <div styleName="complete-text">取り組めた方は完了ボタンを押そう！</div>
                    <Button
                        onClick={() => createCompletion}
                        loading={loading}
                        type="normal"
                        styleName="complete-button"
                        id="complete-button"
                    >
                        完了
                    </Button>
                </div>
            );
    }
};
